import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Search from "antd/es/input/Search";
import {
  Button, Col, message, Popconfirm, Row, notification, Space, Table, Form, Tooltip, Modal, Switch
} from "antd";
import IMAGES from "../../../const/Image";
import Search from "antd/es/input/Search";
import { components, getRowClassName } from "../../../utils/utils";
import { ArrowLeftOutlined } from "@ant-design/icons";
import DashboardRequest from "../DashboardRequest";
const initialFilter = { page: 1, limit: 10 };

function CustomServiceRequest() {
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const { confirm } = Modal;
  const [form] = Form.useForm();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);

  const navigate = useNavigate();

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (_, __, index) => (filter.page - 1) * filter.limit + index + 1,
    },
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Category Name",
      dataIndex: "saloncategory",
      key: "categoryTitle",
      render: (saloncategory) =>
        saloncategory && saloncategory.category
          ? saloncategory.category.categoryTitle
          : "N/A",

    },
    {
      title: "Salon Name",
      dataIndex: "salon",
      key: "salonName",
      render: (salon) =>
        salon ? `${salon.salonName}` : "N/A",
    },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Approved"
          unCheckedChildren="Rejected"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/dashboard/custom-service-requet/view/${record.salonId}`)}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>

        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const fetchServiceList = () => {
    setLoading(true);
    // CategoryRequest.categoryList(searchFilter.page, searchFilter.limit, searchFilter.title)
    const searchFilter = filter.searchTerm;

    DashboardRequest.customerRequestList(filter.page, filter.limit, searchFilter)
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log("rawdata", rawData)
        const totalCount = response?.data?.total || 0;
        setLabList(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch customers.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchServiceList();
  }, [filter]);

  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this service?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        DashboardRequest.UpdateServiceReq({
          id: item.id,
          status: checked ? "1" : "0",
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, status: checked ? 1 : 0 } : el
                )
              );
              // fetchServiceList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  // const handleSearch = (e) => {
  //   const searchValue = e.target.value.toLowerCase();
  //   if (!searchValue) {
  //     fetchServiceList();
  //   } else {
  //     const filteredList = labList.filter((ServiceList) =>
  //       (ServiceList.id && ServiceList.id.toString().toLowerCase().includes(searchValue)) ||

  //       (ServiceList.saloncategory && ServiceList.saloncategory.category && ServiceList.saloncategory.category.categoryTitle.toLowerCase().includes(searchValue)) ||
  //       // Search within the salonName
  //       (ServiceList.salon && ServiceList.salon.salonName.toLowerCase().includes(searchValue)) ||
  //       (ServiceList.serviceName && ServiceList.serviceName.toLowerCase().includes(searchValue))

  //     );
  //     setLabList(filteredList);
  //   }
  // };
  const onSearch = (searchTerm) => {
    setFilter({
      ...filter,
      searchTerm: searchTerm.toLowerCase(),
      page: 1, // Reset to the first page for search results
    });
  };
  return (
    <>
      <div className="">
        <Form.Item className="text-center submit-btn">
          <Space>
            <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
              <ArrowLeftOutlined />
            </Button>
          </Space>
        </Form.Item>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Custom Service Request</h1>
          </Col>


          <Col>

            <div style={{ display: "flex", gap: "1rem" }}>
              <Search
                placeholder="Search..."
                allowClear
                size="large"
                onSearch={onSearch}
                // onChange={handleSearch}
                value={filterForm?.title}
                style={{ width: "100%" }}
              />

            </div>
          </Col>

        </Row>
      </div>
      <div style={{ marginTop: '20px' }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          dataSource={labList}
        />
      </div>
    </>
  )
}






export default CustomServiceRequest